import React from 'react';
import { Trans } from 'react-i18next';
import { Subtitle } from 'react-design-components';
import { Box } from '@material-ui/core';
import useHelp from './hooks/useHelp';

const LocationAmountHelp = () => {
  const { t } = useHelp();
  return (
    <Trans i18nKey="location_amount" t={t}>
      <Box mt={4} mb={2}>
        <Subtitle margined>
          Geben Sie hier bitte die
          <b>Anzahl der Gewerbe-Standorte</b>
          an. Bei mehr als einem Standort erhalten Sie von unseren Prüfern ein persönliches Angebot zur Prüfung der
          gesamten Räumlichkeiten.
        </Subtitle>
      </Box>

      <Box mb={2}>
        <Subtitle>
          Des Weiteren benötigen wir die Anzahl der Standorte zur zeitlichen Einordnung des Prüfprozesses. So können wir
          Ihnen bereits vor der Prüfung ein Datum garantieren, zu dem Sie die geprüften Nebenkostenabrechnungen aller
          Standorte erhalten. Das schafft Planungssicherheit für Sie.
        </Subtitle>
      </Box>
    </Trans>
  );
};

export default LocationAmountHelp;
